import { Bounce, toast } from 'react-toastify';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';
import { useCallback } from 'react';

const useHandleCopyWithToast = () => {
  const { tt } = useUiComponentsInternationalContext();

  return useCallback(
    (
      referralLink: string,
      label = tt(s => s.referralProgramComponent.referralLinkLabel)
    ) => {
      navigator.clipboard
        .writeText(referralLink)
        .then(() => {
          toast.success(
            tt(s => s.referralProgramComponent.copiedToClipboardMessage, {
              label,
            }),
            {
              position: 'bottom-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
              transition: Bounce,
            }
          );
        })
        .catch(err => {
          toast.error(
            tt(
              s =>
                s.referralProgramComponent.couldNotCopyToClipboardErrorMessage,
              {
                label,
              }
            ),
            {
              position: 'bottom-center',
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'light',
              transition: Bounce,
            }
          );
          console.error(err);
        });
    },
    [tt]
  );
};

export default useHandleCopyWithToast;
